import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Route, Routes} from 'react-router-dom'
import { useState } from 'react'
import Container from 'react-bootstrap/Container'
import Header from './components/header.js'
import Footer from './components/footer';
import DateList from './pages/dateList';
import Register from './pages/register';
import LoginUser from './pages/login';
import ShowDate from './pages/showDate';
import ShowIdeas from './pages/showIdeas';
import ShowDecks from './pages/showDecks';
import Shuffle from './pages/shuffle';

function App() {
  const [currentUser, setCurrentUser] = useState({})
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [username, setUsername] = useState("")
  const [loginVisible, setLoginVisible] = useState(true)


  return (
    <div className="App">
      <div className="AppContainer">
          
          <Header mods={{loginVisible, currentUser, setCurrentUser, isAuthenticated, setIsAuthenticated, username, setUsername}} />
          <Container>
            <Routes>
              <Route path="/" element={isAuthenticated ? <DateList mods={{}} /> : <h3>Please Login to Use App</h3>} />
              <Route path="/dates/:id" element={isAuthenticated ? <ShowDate /> : <h4>Please login to use app</h4>} />
              <Route path="/ideas" element={isAuthenticated ? <ShowIdeas mods={{currentUser}} /> : <h4>Please login to use app</h4>} />
              <Route path="/decks" element={isAuthenticated ? <ShowDecks mods={{currentUser}} /> : <h4>Please login to use app</h4>} />
              <Route path="/shuffle" element={isAuthenticated ? <Shuffle mods={{currentUser}} /> : null} />
              <Route path="/auth">
                <Route path="register" element={<Register mods={{currentUser, setCurrentUser, isAuthenticated, setIsAuthenticated, username, setUsername}} />} />
                <Route path="login" element={<LoginUser mods={{setLoginVisible, isAuthenticated, setIsAuthenticated, currentUser, setCurrentUser}} />} />
              </Route>
            </Routes>
          </Container>  
          <Footer />
      </div>
    </div>
  );
}

export default App;
